// extracted by mini-css-extract-plugin
export default {"slot":"film-grid_slot__38HTi","hidden":"film-grid_hidden__3LqeK","card":"film-grid_card__3Ys77"};